<template>
  <v-container>
    <TitleParagraphRow :value="value" />

    <v-row>
      <v-col
        v-for="item in course.detail_section.items"
        :key="item.id"
        cols="12"
      >
        <CourseDetailItem :scroll-to-section="scrollToSection" :value="item" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
defineProps({
  course: {
    required: true,
    type: Object
  },
  scrollToSection: {
    default: undefined,
    type: Function
  },
  value: {
    required: true,
    type: Object
  }
})
</script>
